"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("rect", {
      width: "20",
      height: "20",
      rx: "10",
      fill: "#FFB800"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M9.99231 15.5862C10.4303 15.5862 10.7854 15.2311 10.7854 14.7931C10.7854 14.3551 10.4303 14 9.99231 14C9.5543 14 9.19922 14.3551 9.19922 14.7931C9.19922 15.2311 9.5543 15.5862 9.99231 15.5862Z",
      fill: "white"
    }), (0, jsx_runtime_1.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.99231 14.5862C9.87804 14.5862 9.7854 14.6788 9.7854 14.7931C9.7854 14.9074 9.87804 15 9.99231 15C10.1066 15 10.1992 14.9074 10.1992 14.7931C10.1992 14.6788 10.1066 14.5862 9.99231 14.5862ZM10.7854 14.7931C10.7854 15.2311 10.4303 15.5862 9.99231 15.5862C9.5543 15.5862 9.19922 15.2311 9.19922 14.7931C9.19922 14.3551 9.5543 14 9.99231 14C10.4303 14 10.7854 14.3551 10.7854 14.7931Z",
      fill: "#002255"
    }), (0, jsx_runtime_1.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.99406 4C10.4331 4 10.7891 4.35593 10.7891 4.795L10.7891 11.205C10.7891 11.6441 10.4331 12 9.99406 12C9.555 12 9.19906 11.6441 9.19906 11.205L9.19906 4.795C9.19906 4.35593 9.555 4 9.99406 4Z",
      fill: "#002255"
    })]
  });
};

exports.default = Icon;